import type { EdutainmentCategory } from './types';

// TODO: 假資料，到時要改成用真實資料
export const DUMMY_TABLE_DATASOURCE: EdutainmentCategory[] = [
  {
    _id: '001',
    category: '技藝',
    description: '講究技巧性的武藝、工藝。',
  },
  {
    _id: '002',
    category: '知識',
    description: '講究技巧性的武藝、工藝。',
  },
  {
    _id: '003',
    category: '健康',
    description: '講究技巧性的武藝、工藝。',
  },
];
